export const apiConfig = {
    validateEmbedRequest: (): string => {
        throw new Error("You haven't set the validateEmbedRequest endpoint");
    }
};
